import {createSelectionSlice} from 'entities/monitor';

const portMonitor = createSelectionSlice('portMonitor', ({portMonitorReducer}) => portMonitorReducer);

export default portMonitor.reducer;
export const {toggleOne, selectAllOnPage, clearAll} = portMonitor.actions;

export const portMonitorSelectedIdsSelector = portMonitor.selectedIdsSelector;
export const isSelectedAllSelector = portMonitor.isSelectedAllSelector;
